import SceButton from '../../../../../../../Common/CommonComponents/sceButton';
import classes from './deletePhoneNumberDialog.scss';
import { getLocalizedStrings } from '../../../notificationLocalizedStrings';

const DeletePhoneNumberDialog = (props) => {

  const strings = getLocalizedStrings('dialogBox');
  return (

    <div className={classes.sceDeleteEmailDialog}>
      <div className={'row ' + classes.sceDeleteEmailDialogWrap}>
        <div className={'col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 ' + classes.sceDeleteEmailDialogMain}>
          <div className={classes.sceCancelDialogSection}>
            <div className={classes.sceCancelDialogInfo}>
              <div className={classes.sceDialogMainContent}>{strings.deletePhoneNumberHeading}</div>
              <div className={classes.sceDialogSubContent}>
                <p>{strings.deletePhoneNumberSubHeading}</p>
                <p><b>{props.deleteValue}</b></p>
                <p>{strings.deletePhoneNumberInfo}</p>
              </div>

            </div>
            <div className={'row ' + classes.sceCancelDialogActions}>
              <div className={'col-xs-12 col-sm-6 col-sm-push-6 ' + classes.sceConfirmBtn}>
                <SceButton
                  id='cancelDialogYes'
                  buttonType='default'
                  value={strings.btnConfirm}
                  responive='false'
                  onClick={() => {
                    props.onConfirmDeletePhoneDialogClick();
                  }}
                />
              </div>
              <div className={'col-xs-12 col-sm-6 col-sm-pull-6 ' + classes.sceCancelBtn}>
                <SceButton
                  id='cancelDialogNo'
                  buttonType='sceClose'
                  value={<span id={'cancelDialogno'}>{strings.btnCancel}</span>}
                  responive='false'
                  onClick={(e)=>props.onCancelClickHandler(e)}
                  iconType='cancel'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};
export default DeletePhoneNumberDialog;